import { Label } from 'office-ui-fabric-react';

export const ImpersonationContainer = styled.div`
  width: auto;
  height: auto;
  background-color: rgba(255, 244, 206, 1);
  padding: 10px;
  margin-bottom: 10px;
  text-align: center;
`;

export const ImpersonationPageContainer = styled.div`
  display: -webkit-box;
  display: -moz-box;
  display: -ms-flexbox;
  display: -moz-flex;
  display: -webkit-flex;
  display: flex;
  justify-content: center;
  -webkit-flex-wrap: wrap;
  flex-wrap: wrap;
  margin-top: -15px;
`;

export const ImpersonationLabel = styled(Label)`
  margin-right: 15px;
  margin-left: 15px;
`;

export const ControlContainer = styled.div`
  display: flex;
  margin-top: 15px;
  margin-right: 15px;
`;
